define(["backbone", "messaging/messenger", "modules/shared/adminMenu/adminMenuModel"], function (
  Backbone,
  Messenger,
  AdminMenuModel,
) {
  Messenger.reqres.setHandler("authoring:admin:menu:items", async function () {
    const user = Messenger.reqres.request("user");
    const isGlobalAdmin = user.get("globalAdmin");
    const isTenantAdmin = user.get("admin");
    const kbModel = Messenger.reqres.request("active:kb:model");
    await kbModel.onSyncedPromise();
    let menuItems;

    if (isGlobalAdmin || isTenantAdmin) {
      menuItems = new AdminMenuModel.menuItems([
        { name: "apis", label: "admin.title.apis" },
        { name: "attributes", label: "admin.title.attributes" },
        { name: "campaigns", label: "admin.title.campaigns" },
        { name: "categories", label: "admin.title.categories" },
        { name: "conversationVariables", label: "admin.title.conversationVariableTitle" },
      ]);

      if (kbModel && kbModel.get("siteMapAccess")) {
        menuItems.add({ name: "siteMaps", label: "admin.title.siteMaps" });
      }
      menuItems.add({ name: "tableOfContents", label: "admin.title.tableOfContents" });
      menuItems.add({ name: "topicListing", label: "admin.title.topicListing" });
    }

    return menuItems;
  });

  Messenger.reqres.setHandler("authoring:admin:menu:style", function () {
    return new AdminMenuModel.menuType({ type: "pills", stacked: true });
  });
});
